import { useCallback } from "react";

import { useBxpWebStargateClient } from "@/libraries/bxp-web-stargate-client/src";

import { useSampleProjectConfiguration } from "../views/sample-project/controllers";

import { useCloudStatus } from "./use-cloud-status";

export const useCreateSampleProject = () => {
    const { cloudId } = useCloudStatus();
    const stargateClient = useBxpWebStargateClient();
    const { teamType, projectDetails, sampleProjectConfiguration } =
        useSampleProjectConfiguration();

    const createSampleProject = useCallback(async () => {
        try {
            const { projectId } = await stargateClient.sampleProjectCreate({
                cloudId,
                teamType: teamType,
                template: projectDetails.template,
                projectKey: projectDetails.projectKey,
                issueTypes: sampleProjectConfiguration.issueTypes,
                statusNames: sampleProjectConfiguration.columns,
                projectName: projectDetails.defaultProjectName
            });

            const promises: Promise<boolean>[] = [];

            const putSampleProjectUserPropertyPromise =
                stargateClient.putSampleProjectUserProperties({
                    projectId,
                    tenantId: cloudId
                });

            promises.push(putSampleProjectUserPropertyPromise);

            await Promise.all(promises);

            return projectId;
        } catch (error) {
            // TODO: Send analaytics event to indicate that the sample project was not created.
            console.error("Error creating sample project:", error);
        }

        return undefined;
    }, [
        stargateClient,
        cloudId,
        teamType,
        projectDetails,
        sampleProjectConfiguration
    ]);

    return { createSampleProject };
};
